<template>
  <b-card no-body>
    <b-card-body>
      <b-form-checkbox
        v-model="allItems"
        name="check-button"
        switch
        inline
      >
        Tamamlananları Göster
      </b-form-checkbox>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      fixed
    >
      <template #cell(remind)="data">
        <div class="d-flex align-content-start">
          <div>
            <b-form-checkbox
              v-model="data.item.status"
              value="0"
              @change="changeStatus(data.item.id)"
            />
          </div>
          <div :class="data.item.status === '0'? 'completed' : ''">
            {{ moment(data.item.remind).format('LL') }}
          </div>
        </div>
      </template>
      <template #cell(content)="data">
        <div class="d-flex align-content-start">
          <div>
            <b-button
              v-b-tooltip.hover.top="'Görüşmeyi Görüntüle'"
              variant="flat-success"
              class="btn-icon rounded-circle"
              :to="'/app/interviews/view/' + data.item.id_interviews"
              :disabled="data.item.status === '0'"
            >
              <FeatherIcon icon="EyeIcon" />
            </b-button>
          </div>
          <div :class="data.item.status === '0'? 'completed' : ''">
            {{ data.item.content }}
            <div class="text-primary font-small-2">
              {{ data.item.company }}
            </div>
          </div>
        </div>
      </template>
      <template #cell(control)="data">
        <list-buttons
          v-if="data.item.status === '1'"
          :edit-action="$route.path + '/edit/' + data.item.id"
          :delete-action="removeData"
          :data-id="data.item.id"
        />
        <FeatherIcon
          v-else
          icon="LockIcon"
        />
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BCardFooter, BButton, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const tableName = 'reminders'
export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BCardFooter,
    BButton,
    BFormCheckbox,
    ListButtons,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      allItems: false,
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'remind',
          label: 'TARİH',
          thClass: 'width-150',
          tdClass: 'text-nowrap',
        },
        {
          key: 'content',
          label: 'HATIRLATMA',
        },
        {
          key: 'control',
          label: '',
          tdClass: 'text-right',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.content AS content`,
          `${tableName}.remind AS remind`,
          `${tableName}.status AS status`,
          'customers.company AS company',
          `${tableName}.status AS status`,
          `${tableName}.id_interviews AS id_interviews`,
        ],
        where: {
          'reminders.status': 1,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['reminders/dataList']
    },
    dataCounts() {
      return this.$store.getters['reminders/dataCounts']
    },
    saveData() {
      return this.$store.getters['reminders/dataSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
    allItems(val) {
      if (val) {
        this.dataQuery.where = {}
      } else {
        this.dataQuery.where = { 'reminders.status': 1 }
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('reminders/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('reminders/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
    changeStatus(id) {
      this.$store.dispatch('reminders/changeStatus', id)
    },
  },
}
</script>
<style scoped>
  .completed{
    text-decoration: line-through !important;
  }
</style>
